import {
  FETCH_SYSTEMS_FAIL,
  FETCH_SYSTEMS_START,
  FETCH_SYSTEMS_SUCCESS,
  RESET_SYSTEMS,
  UPDATE_SYSTEM_CONNECTION_STATUS,
  UPDATE_SYSTEMS
} from "../actionTypes/systemsAndLiveAlarms";

export const fetchSystemsSuccess = systems => ({
  type: FETCH_SYSTEMS_SUCCESS,
  payload: { systems }
});

export const updateSystems = payload => ({
  type: UPDATE_SYSTEMS,
  payload
});

export const updateSystemsConnection = payload => ({
  type: UPDATE_SYSTEM_CONNECTION_STATUS,
  payload
});

export const fetchSystemsFail = error => ({
  type: FETCH_SYSTEMS_FAIL,
  payload: { error }
});

export const fetchSystemsStart = () => ({ type: FETCH_SYSTEMS_START });
export const resetSystemsAction = () => ({ type: RESET_SYSTEMS });
